<ion-toggle [checked]="darkMode()" class="dark-mode-toggle" (ionChange)="onToggle($event)"></ion-toggle>
